import {
  PASSWORD_REQUIREMENTS,
  passwordRequirementChecks,
} from '@/lib/passwordPolicy';

type PasswordRequirementsChecklistProps = {
  password: string;
};

const REQUIREMENT_KEYS = ['minLength', 'uppercase', 'number'] as const;

export function PasswordRequirementsChecklist({
  password,
}: PasswordRequirementsChecklistProps) {
  const checks = passwordRequirementChecks(password);

  return (
    <ul aria-live="polite" className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
      {PASSWORD_REQUIREMENTS.map((label, index) => {
        const key = REQUIREMENT_KEYS[index];
        const met = checks[key];
        return (
          <li
            key={key}
            data-requirement={key}
            data-met={met ? 'true' : 'false'}
            className={met ? 'text-teal-700 dark:text-teal-400' : ''}
          >
            {met ? '✓' : '•'} {label}
          </li>
        );
      })}
    </ul>
  );
}
